import { useInfiniteQuery } from "@tanstack/react-query";
import { useAccountID } from "./account";
import { useShowID } from "./show";
import axios from "axios";

export const useEpisodeComparison = () => {
    const accountID = useAccountID();
    const showID = useShowID();
    return useInfiniteQuery(
        {
            queryKey: ["episode-comparison", accountID, showID],
            queryFn: ({ pageParam = 0 }) =>
                axios.get(`/api/${ accountID }/metrics/shows/${ showID }/episode-comparison?page=${ pageParam }`)
                    .then(res => res.data),
            getNextPageParam: (lastPage, pages) => lastPage.nextPage
        }
    );
};
